import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthLocalService } from '../services/auth/local/auth-local.service';

@Injectable({
	providedIn: 'root'
})
class PermissionsService {
	constructor(
		private authLocalService: AuthLocalService,
		private _router: Router
	) {}

	canActivate(): boolean {
		if (this.authLocalService.isLogued()) {
			return true;
		} else {
			if (this.authLocalService.isNewPassword) {
				return true;
			} else {
				this._router.navigate(['/autenticar']);
				return false;
			}
		}
	}
}

export const PasswordGuard: CanActivateFn = (): boolean => {
	return inject(PermissionsService).canActivate();
};
